import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@airbus/components-react/components/Modal'
import { TableCell, Table, TableHead, TableBody, TableRow, Container } from '@airbus/components-react/components'
import GoToTop from 'components/goToTop'
import URL_APIS from 'utils/api/urlApis'
import PageHeader from 'components/pageHeader'
import { UserQualification } from 'types/workorder/manHour'
import useQuery from 'utils/hooks/useQuery'
import LightDarkContext from 'context/LightDarkModeContext'

const ID_SCROLL_COMPONENT_FOR_GOTOTOP = 'modalPnGoToTop'

type Props = {
  lang: Lang
  isOpened: boolean
  surcode: string
  onCloseModal: () => void
  onQualificationSelected: (uq: UserQualification) => void
}

const styleModal = {
  position: 'absolute',
  transform: 'translate(50%, 50%)',
  width: '50%',
  height: '50%',
  border: '2px solid #000',
  boxShadow: 24,
  overflowY: 'scroll',
  scrollbarWidth: 'none',
}

const ModalQualification = ({ lang, isOpened, onCloseModal, surcode, onQualificationSelected }: Props) => {
  const { t } = useTranslation()

  const [data, setData] = useState<UserQualification[]>()
  const [isLoading, setIsLoading] = useState(false)

  const { fetchData: fetchQualifications } = useQuery<UserQualification[]>(
    URL_APIS.URL_WORKORDER_STAFF_QUALIFICATIONS_GET,
  )

  const loadData = async () => {
    setIsLoading(true)

    const qualificationsResponse = await fetchQualifications({
      code: surcode,
    })
    setIsLoading(false)

    setData(qualificationsResponse?.data?.content)
  }

  useEffect(() => {
    if (isOpened && surcode) {
      loadData()
    }

    return () => setData([])
  }, [surcode, isOpened])

  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <Modal
      open={isOpened}
      onClose={onCloseModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <div style={{ ...styleModal, backgroundColor: getBackgroundColor() }} id={ID_SCROLL_COMPONENT_FOR_GOTOTOP}>
        <>
          <PageHeader
            pageTitle={t('modal_search_qualification')}
            modalEmbedded={true}
            modalOnClose={onCloseModal}
            style={{ top: 0 }}
            localLoading={isLoading}
          />

          <Container style={{ flex: 1 }} fixed>
            <div style={{ padding: '1em' }}>
              {data && data.length > 0 ? (
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t('7000914')}</TableCell>
                      <TableCell>{t('1CEF000')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row: UserQualification, i: number) => (
                      <TableRow
                        key={'userQualification_' + i}
                        hover={true}
                        onClick={() => onQualificationSelected(row)}
                      >
                        <TableCell>{row?.qualification}</TableCell>
                        <TableCell>{row?.applicability}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <div>{t('9500055')}</div>
              )}
            </div>
          </Container>
          <GoToTop idComponentForScroll={ID_SCROLL_COMPONENT_FOR_GOTOTOP} />
        </>
      </div>
    </Modal>
  )
}

export default ModalQualification
